import { render, staticRenderFns } from "./modal-task-columns.vue?vue&type=template&id=f0cceff0&scoped=true"
import script from "./modal-task-columns.vue?vue&type=script&lang=js"
export * from "./modal-task-columns.vue?vue&type=script&lang=js"
import style0 from "./modal-task-columns.vue?vue&type=style&index=0&id=f0cceff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cceff0",
  null
  
)

export default component.exports